<div class="flex flex-col gap-6">
	<h5 class="font-medium text-base">
		Are you sure you want to cancel your intake request?
	</h5>
	<p class="font-normal text-base">
		This will erase any unsaved changes you have made to your intake form.
	</p>
</div>
